export default {
    url: '/search/:keyword',
    template: `
        <div class="col00">
            <h1>{{ 'search.Results for' | translate }} "{{ vm.keyword }}"</h1>
            <ul class="tabs01">
                <li ng-if="vm.PrivilegeService.canViewCourses()">
                    <a ui-sref="authorized.search.courses()" ng-class="{ active: vm.$state.includes('authorized.search.courses') }">{{ 'search.Courses' | translate }}</a>
                    </li>
                <li ng-if="vm.PrivilegeService.canViewUsers()">
                    <a ui-sref="authorized.search.employees()" ng-class="{ active: vm.$state.includes('authorized.search.employees') }">{{ 'search.Employees' | translate }}</a>
                </li>
            </ul>
            <ui-view></ui-view>
        </div>
    `,
    abstract: true,
    controller ($state, $stateParams, PrivilegeService) {
        this.$state = $state;
        if (!$stateParams.keyword) {
            $state.go('authorized.home');
        }
        this.keyword = $stateParams.keyword;
        this.PrivilegeService = PrivilegeService;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/search/index.js